<template>
  <div class="staff-activity">
    <div class="d-flex flex-wrap align-items-center mb-2">
      <span class="mr-1">期间(기간)</span>
      <input v-model="from" type="date" class="form-control form-control-sm staff-activity__date mr-1">
      <span class="mr-1">~</span>
      <input v-model="to" type="date" class="form-control form-control-sm staff-activity__date mr-2">
      <select v-model="account" class="form-control form-control-sm staff-activity__select mr-2">
        <option value="">全部账号(계정 전체)</option>
        <option v-for="s in staff" :key="s.email" :value="s.email">{{ s.name || s.email }} ({{ s.email }})</option>
      </select>
      <select v-model="type" class="form-control form-control-sm staff-activity__select mr-2">
        <option value="">全部操作(작업 전체)</option>
        <option v-for="(label, key) in typeLabels" :key="key" :value="key">{{ label }}</option>
      </select>
      <button class="btn btn-sm btn-primary" type="button" :disabled="loading" @click="load">查询(조회)</button>
    </div>
    <div class="table-responsive staff-activity__list">
      <table class="table table-sm">
        <thead>
          <tr><th>时间(시각)</th><th>账号(아이디)</th><th>姓名(이름)</th><th>操作(작업)</th><th>内容(내용)</th><th>对象(대상)</th></tr>
        </thead>
        <tbody>
          <tr v-for="(r, i) in rows" :key="i">
            <td class="text-nowrap">{{ formatTime(r.at) }}</td>
            <td>{{ r.account || '-' }}</td>
            <td>{{ r.name }}</td>
            <td>{{ typeLabels[r.type] || r.type }}</td>
            <td>{{ detailText(r) }}</td>
            <td>{{ r.target }}</td>
          </tr>
          <tr v-if="!rows.length">
            <td colspan="6" class="text-center text-muted">{{ loaded ? '暂无记录(기록 없음)' : '请选择期间后查询(기간을 고르고 조회해 주세요)' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <small v-if="truncated" class="d-block text-warning">只显示最近500条，请缩小期间(최근 500줄만 보입니다 — 기간을 줄여 주세요)</small>
    <small class="d-block text-muted">包括: 入库处理·出库清单上传·条码打印·客服助手回复·子账号管理。采购阶段的状态变更请在各订单的处理记录中查看(포함: 입고처리·출고리스트 올리기·바코드 출력·CS 보조 답장·직원 계정 관리. 구매 단계 상태 변경은 각 주문의 처리 기록에서 확인해 주세요). 条码打印从本次更新开始记录(바코드 출력은 이번 업데이트부터 기록).</small>
  </div>
</template>

<script>
import axios from 'axios';

const TYPE_LABELS = {
  receipt: '入库处理(입고처리)',
  ship: '出库(출고)',
  barcode: '条码打印(바코드 출력)',
  cs: '客服回复(CS 답장)',
  account: '子账号管理(직원 계정)',
};
const CS_ACTION = { 'as-is': '直接采用草稿(초안 그대로)', edited: '修改草稿后发送(초안 고쳐서)', own: '自己输入(직접 입력)', discarded: '放弃草稿(초안 버림)' };
const ACCOUNT_ACTION = {
  create: '创建(생성)', deactivate: '停用(비활성화)', activate: '启用(재활성화)', 'reset-password': '重置密码(비번 초기화)',
  update: '修改信息(정보 수정)', delete: '删除(삭제)', groups: '修改分类(분류 수정)',
};

function cnDate(offsetDays) {
  return new Date(Date.now() + 8 * 3600e3 + (offsetDays || 0) * 864e5).toISOString().slice(0, 10);
}

export default {
  name: 'CoupassStaffActivity',
  props: {
    staff: { type: Array, default: () => [] },
  },
  data() {
    return { from: cnDate(-2), to: cnDate(0), account: '', type: '', rows: [], truncated: false, loading: false, loaded: false, typeLabels: TYPE_LABELS };
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await axios.post('/api/coupass-staff/activity', { from: this.from, to: this.to, account: this.account, type: this.type });
        if (res.data && res.data.success) {
          this.rows = res.data.rows || [];
          this.truncated = !!res.data.truncated;
          this.loaded = true;
        }
      } catch (e) {
        console.error('작업 기록 조회 실패:', e);
        alert((e.response && e.response.data && e.response.data.message) || '查询失败(조회 실패)');
      } finally {
        this.loading = false;
      }
    },
    detailText(r) {
      if (r.type === 'cs') return CS_ACTION[r.detail] || r.detail;
      if (r.type === 'account') return ACCOUNT_ACTION[r.detail] || r.detail;
      if (r.type === 'barcode') return r.detail + ' 张(장)';
      return r.detail + ' 个(개)';
    },
    formatTime(t) {
      if (!t) return '';
      const d = new Date(t);
      return isNaN(d.getTime()) ? String(t) : d.toLocaleString();
    },
  },
};
</script>

<style lang="scss" scoped>
.staff-activity {
  &__date { max-width: 150px; }
  &__select { max-width: 240px; }
  &__list { max-height: 520px; overflow-y: auto; }
}
</style>
